<app-loading-indicator *ngIf="!categories || !project">{{ 'projects.jobs.details.images-loading' | translate }} </app-loading-indicator>
<ng-container *ngIf="categories != null && project != null">
    <ion-row class="job-photos-wrap">
        <ion-col
            tabindex="0"
            sizeSm="12"
            [sizeMd]="categories.length > 1 ? 6 : 12"
            [ngClass]="categories.length > 1 ? 'notFullWidth' : ''"
            class="job-photos-category"
            *ngFor="let category of categories"
        >
            <ion-card class="dp-mt-0 dp-ml-0 dp-mr-0">
                <ion-card-header>
                    <ion-card-title class="ion-display-flex ion-align-items-center ion-justify-content-between">
                        <div class="ion-display-flex ion-align-items-center">
                            {{ category.categoryName }}
                            <span
                                class="dp-pl-s ion-display-flex ion-align-items-center"
                                dpTooltip
                                [tooltipContent]="
                                    'projects.jobs.details.allowed-filetypes'
                                        | translate: { allowedFileTypes: getTranslatedFileTypes(category.fileType) }
                                "
                                tooltipTrigger="click mouseenter focus"
                                tooltipPosition="top"
                            >
                                @if (category.fileType.length === 1) {
                                    <ion-icon *ngIf="category.fileType.includes('image')" name="image-outline"></ion-icon>
                                    <ion-icon *ngIf="category.fileType.includes('video')" name="videocam-outline"></ion-icon>
                                    <ion-icon *ngIf="category.fileType.includes('audio')" name="musical-note-outline"></ion-icon>
                                    <ion-icon *ngIf="category.fileType.includes('pdf')" name="document-outline"></ion-icon>
                                } @else {
                                    <ion-icon name="attach-outline"></ion-icon>
                                }
                            </span>
                        </div>
                    </ion-card-title>
                </ion-card-header>
                <ion-card-content
                    cdkDropList
                    [cdkDropListDisabled]="!changesAllowed"
                    [cdkDropListData]="{ categoryName: category.categoryName, fileType: category.fileType }"
                    (cdkDropListDropped)="onDropPhoto($event, category.categoryName)"
                    (dragover)="$event.preventDefault()"
                    (drop)="onCategoryNativeDrop($event, category.categoryName)"
                >
                    <div class="job-photo-list">
                        <div
                            class="job-photo dp-mb-s"
                            [attr.draggable]="changesAllowed"
                            cdkDrag
                            [cdkDragDisabled]="!utils.isPhone && !utils.isTablet && !altPressed"
                            [cdkDragStartDelay]="utils.isPhone || utils.isTablet ? { touch: 100, mouse: 0 } : 0"
                            [cdkDragData]="{
                                photo: photo,
                                sourceType: 'job-photos',
                                sourceCategoryName: category.categoryName,
                            }"
                            (cdkDragEntered)="onDragEntered($event)"
                            (dragstart)="onPhotoDragStart($event, photo, category.categoryName)"
                            *ngFor="let photo of getPhotosByCategory(category.categoryName); index as photoIndex"
                        >
                            <app-attachment-view
                                [attachment]="photo"
                                (attachmentDeleted)="this.onRemovePhoto($event)"
                                (attachmentUpdated)="onPhotoUpdated($event)"
                                [canDelete]="changesAllowed"
                                [canEdit]="changesAllowed"
                                [showCreationTime]="showPhotoDate"
                                [allowNotices]="true"
                                [overrideDownloadFileName]="
                                    job.name.substring(0, 5) + '-' + job.jobNumber + '-' + category.categoryName + '-' + (photoIndex + 1)
                                "
                            ></app-attachment-view>
                            <ng-template cdkDragPlaceholder>
                                <div class="drag-placeholder" [ngClass]="!dragTargetAllowed ? 'drag-error' : ''">
                                    @if (!dragTargetAllowed) {
                                        {{ 'core.attachment.errors.file-type-not-allowed-err' | translate }}
                                    } @else {
                                        {{ 'projects.info.form.drop-attachment-here' | translate }}
                                    }
                                </div>
                            </ng-template>
                            <ng-template cdkDragPreview matchSize="true">
                                <div>
                                    <app-attachment-view
                                        [attachment]="photo"
                                        [canDelete]="false"
                                        [canEdit]="false"
                                        [allowNotices]="false"
                                        [showCreationTime]="false"
                                    ></app-attachment-view>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                    <ng-container *ngIf="changesAllowed && !category.readonly">
                        <hr class="divider" />
                        <div class="ion-text-center">
                            <app-attachment-select
                                [dialog]="false"
                                [allowedFileTypes]="category.fileType"
                                [folder]="project._id + '/jobs/' + job._id"
                                [lockCameraOrientation]="category.lockCameraOrientation"
                                (fileSelected)="onAddPhoto($event, category.categoryName)"
                                [buttonText]="'projects.jobs.details.upload-image-btn' | translate"
                            ></app-attachment-select>
                        </div>
                    </ng-container>
                </ion-card-content>
            </ion-card>
        </ion-col>
    </ion-row>
</ng-container>
